import api from "../../../services/axiosConfig";

export const fetchProjects = async () => {
  try {
    const response = await api.get(
      "/instances/governeye/jeyeda/list-projects",
      {
        data: {},
      },
    );
    return response.data.data.projects;
  } catch (error) {
    console.error("Error fetching projects:", error);
    throw error;
  }
};
